import React from 'react'
import { shallow } from 'enzyme'
import { FinancialDocument } from '../FinancialDocument'
import business from '../../financial_review/specs/testData/business'
import * as ReactApollo from 'react-apollo';

describe('FinancialDocument', () => {
  let wrapper, props, instance

  const docProps = {
    skipped: false,
    confirmed: false,
    status: 'pending_review',
    uploaded: false,
    skippable: false,
    referenceFiles: "[]",
    adminOnly: false,
    deletable: false,
    displayCommentable: false,
    esignable: false,
    live: true,
    rid: 123,
    title: 'title',
    type: 'Document::Custom',
    fileUrls: [
      {
        "filename": "pdf-sample_2021-12-03_19_26_41_UTC_3a76c5bb.pdf",
        "link": "/admin/loans/22588/download_file?document=330623&filename=pdf-sample_2021-12-03_19_26_41_UTC_3a76c5bb.pdf",
        "rid": 595150722
      }
    ],
    files: [
      {
        is_new: false,
        name: 'foo.jpg'
      }
    ]
  }

  beforeAll( () => {
    props = {
      superUser: true,
      loanId: 123,
      loan: {
        cre: false,
        appNumber: '123456',
        product: {
          category: 'working_capital'
        }
      },
      entity: {
        borrowerType: 'oc'
      },
      document: {
        ...docProps,
        files: []
      },
      entityId: 123,
      client: {},
      resourceType: 'Archived'
    }
    wrapper = shallow(<FinancialDocument {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    it('should return obj', () => {
      expect(typeof wrapper).toBe('object')
    })
  })

  describe('#renderStatus', () => {
    // renderStatus = hasReferences => Boolean
    describe('when has no references', () => {
      it('should return obj', () => {
        const obj = instance.renderStatus(false)

        expect(typeof obj).toBe('object')
        expect(JSON.stringify(obj)).toContain('children')
        expect(JSON.stringify(obj)).toContain('No Documents Uploaded')
      })

      describe('when skipped', () => {
        beforeEach(() => {
          props.document.skipped = true
          wrapper.setProps({ ...props })
        })

        describe('when is super user', () => {
          it('should return obj', () => {
            props.superUser = true
            wrapper.setProps({ ...props })
            const obj = instance.renderStatus(false)

            expect(typeof obj).toBe('object')
            expect(JSON.stringify(obj)).toContain('children')
            expect(JSON.stringify(obj)).toContain('No Documents Uploaded')
          })
        })

        describe('when is not super user', () => {
          beforeEach(() => {
            props.superUser = false
            wrapper.setProps({ ...props })
          })

          it('should return obj', () => {
            const obj = instance.renderStatus(false)

            expect(typeof obj).toBe('object')
            expect(JSON.stringify(obj)).toContain('children')
            expect(JSON.stringify(obj)).toContain('No Documents Uploaded')
          })
        })
      })
    })

    it('should return obj if references', () => {
      const obj = instance.renderStatus(true)

      expect(typeof obj).toBe('object')
      expect(JSON.stringify(obj)).not.toContain('children')
    })
  })

  describe('#renderStatusFiles', () => {
    // renderStatusFiles = reference => Hash
    it('should return div if no reference or no files', () => {
      const obj = instance.renderStatusFiles()
      expect(typeof obj).toBe('object')
      expect(JSON.stringify(obj)).toContain('No Documents Uploaded')
    })

    it('should return a status selector', () => {
      wrapper.setProps({
        document: {
          ...docProps,
          files: [{ name: 'one' }],
          fileUrls: [{ filename: 'one' }]
        }
      })
      const obj = instance.renderStatusFiles({date: new Date(), status: 'PENDING_REVIEW'})
      expect(typeof obj).toBe('object')
      expect(JSON.stringify(obj)).toContain('status_select')
    })
  })

  describe('#renderContainer', () => {
    // renderContainer = reference => Hash
    it('should return obj', () => {
      const obj = instance.renderContainer()
      expect(typeof obj).toBe('object')
    })

    it('should include title if reference', () => {
      const obj = instance.renderContainer({date: new Date(2018, 3,18), status: 'PENDING_REVIEW'})
      expect(JSON.stringify(obj)).toContain('April 2018')
    })

    it('should render id', () => {
      const obj = instance.renderContainer()
      expect(JSON.stringify(obj)).toContain('document_bucket_box')
    })
  })

  describe('#renderContainer', () => {
    // renderContainer = reference => Hash
    it('should return obj', () => {
      const obj = instance.renderContainer()
      expect(typeof obj).toBe('object')
    })

    it('should include title if reference', () => {
      const obj = instance.renderContainer({date: new Date(2018, 3,18), status: 'PENDING_REVIEW'})
      expect(JSON.stringify(obj)).toContain('April 2018')
    })

    it('should render id', () => {
      const obj = instance.renderContainer()
      expect(JSON.stringify(obj)).toContain('document_bucket_box')
    })
  })


  describe('#render1919StatusIcon', () => {
    let documentIconResult;

    it('show loading DocumentIcon', () => {
      documentIconResult = instance.render1919StatusIcon('loading')

      expect(documentIconResult.props.loading).toBeTruthy()
    })

    it('show success DocumentIcon', () => {
      documentIconResult = instance.render1919StatusIcon('success')

      expect(documentIconResult.props.loading).toBeFalsy()
      expect(documentIconResult.props.className).toEqual('fa fa-check')
    })

    it('show error DocumentIcon', () => {
      documentIconResult = instance.render1919StatusIcon('error')

      expect(documentIconResult.props.loading).toBeFalsy()
      expect(documentIconResult.props.className).toEqual('fa fa-exclamation')
    })
  })

  describe('#update1919s', () => {
    it('should update documentStatus1919 state correctly', async () => {
      const regenerate1919s = jest.fn().mockResolvedValue();

       jest.spyOn(ReactApollo, 'compose').mockImplementation((...funcs) => {
        return ()=> { return ()=> {} }
      });

      const financialDocumentInstance = wrapper.instance();

      financialDocumentInstance.setState = jest.fn();
      await financialDocumentInstance.update1919s();

      expect(financialDocumentInstance.setState).toHaveBeenCalledTimes(2);
    });
  });

  describe('#renderRegenerate1919Button', () => {
    // renderContainer = reference => Hash
    it('should return obj', () => {
      const obj = instance.renderRegenerate1919Button(false, true, false)
      expect(typeof obj).toBe('object')
    })

    it('should include title if reference', () => {
      const obj = instance.renderContainer();

      expect(typeof obj).toBe('object')
    })
  })

  describe('#updateDocumentData', () =>{
    let store
    beforeAll(() => {
      store = {
        readQuery: () => {
          return {}
        },
        writeQuery: () => {
          return true
        }
      }
    })

    it('should not redirect when state is not forms verified', () => {
      const url = instance.updateDocumentData({}, store, 'forms_verified')
      expect(url).toBeFalsy()
    })

    it('redirect when state is forms verified', () => {
      delete global.window.location;
      global.window = Object.create(window);
      global.window.location = {
        href: 'http://dummy.com',
        pathname: '/verify_forms',
        reload: () => true
      };

      props.loanState = 'forms_verified'
      wrapper.setProps({ props })
      const redirect = instance.updateDocumentData({}, store, 'forms_verified')
      expect(redirect).toBe('/admin/loans/123456')
    })
  })

  describe('#getLatestTaxReturn', () => {
    beforeEach(() => {
      business.taxReturns = [
        {
          year: '2016',
          formName: '1040C',
          rid: 450,
          __typename: 'TaxReturn'
        },
        {
          year: '2018',
          formName: '1040C',
          rid: 449,
          __typename: 'TaxReturn'
        },
        {
          year: '2012',
          formName: '1040C',
          rid: 448,
          __typename: 'TaxReturn'
        }
      ]
    })

    it('should return most recent taxReturn', () => {
      const tax = instance.getLatestTaxReturn(business)
      expect(tax.year).toEqual("2018")
    })

    it('should return false', () => {
      beforeEach(() => {
        business.taxReturns = []
      })
      const tax = instance.getLatestTaxReturn(business)
      expect(tax).toBeFalsy
    })
  })

  describe('#removeOption', () => {
    let options
    beforeEach(() => {
      const statusOptions = {
        esign_requested: 'E-Sign Requested',
        not_required:    'Not Required'
      }
      options = Object.keys(statusOptions)
    })

    it('removes option from the option list', () => {
      instance.removeOption(options, 'esign_requested')
      expect(JSON.stringify(options)).not.toContain('esign_requested')
    })
  })

  describe('#renderOptions', () => {
    it('should not include move_to_archived option', () => {
      const object = instance.renderOptions()
      expect(JSON.stringify(object)).not.toContain('move_to_archived')
      expect(JSON.stringify(object)).toContain('un_archive')
    })

    it('should not include un_archive option', () => {
      wrapper.setProps({ ...props, resourceType: 'Business',customerService: true})
      const object = instance.renderOptions()
      expect(JSON.stringify(object)).toContain('move_to_archived')
      expect(JSON.stringify(object)).not.toContain('un_archive')
    })

    it('should include move_to_archived option if doc can be manually archived', () => {
      wrapper.setProps({ ...props, customerService: true, resourceType: 'Business', document: { ...docProps, canBeManuallyArchived: true } })
      const object = instance.renderOptions()
      expect(JSON.stringify(object)).toContain('move_to_archived')
      expect(JSON.stringify(object)).not.toContain('un_archive')
    })

    it('should include un_archive option if it is archived and it can be manually archived', () => {
      wrapper.setProps({ ...props, customerService: true, type: 'Document::BalanceSheet', document: { ...docProps, canBeManuallyArchived: true } })
      const object = instance.renderOptions()
      expect(JSON.stringify(object)).toContain('un_archive')
      expect(JSON.stringify(object)).not.toContain('move_to_archived')
    })
  })

  describe('#getEntity', () => {
    it('returns the entity with entityId', () => {
      const object = instance.getEntity(business.guarantors, business.guarantors[0].rid)
      expect(object).toEqual(business.guarantors[0])
    })
  })

  describe('#updateDocumentByIndex', () => {
    let document
    beforeEach(() => {
      document = {
        ...docProps,
        files: []
      }

      business.documents = [
        document
      ]
    })

    it('when status is pending_review', () => {
      const object = instance.updateDocumentByIndex(business.documents, document.rid, 'pending_review', document)
      expect(business.documents.length).toEqual(1)
    })

    it('when status is un_archive', () => {
      const object = instance.updateDocumentByIndex(business.documents, document.rid, 'un_archive', document)
      expect(business.documents.length).toEqual(0)
    })
  })

  describe('#documentsConfirmed', () => {
    let entities
    beforeAll(() => {
      business.documents = [
        {
          status: 'approve_and_commit',
          files: []
        },
        {
          status: 'not_required',
          files: []
        },
        {
          status: 'pending_review',
          files: []
        }
      ]
    })
    it('when documnets are not approved', () => {
      entities = [ business ]
      expect(instance.documentsConfirmed(entities)).toBeFalsy()
    })
    it('when documnets are approved', () => {
      business.documents[2].status = 'not_required'
      entities = [ business ]
      expect(instance.documentsConfirmed(entities)).toBeTruthy()
    })
  })

  describe('#directUrlToGlobalSearchPage', () => {
    it('returns url to global search page', () => {
      const object = instance.directUrlToGlobalSearchPage(props.loan.appNumber)

      expect(object).toEqual('/admin/loans/123456')
    })
  })

  describe('#isDocumentType4506', () => {
    it('when document is not 4506', () => {
      const object = instance.isDocumentType4506(props.document.type)

      expect(object).toBeFalsy()
    })

    it('when document is not 4506', () => {
      props.document.type = 'Document::T4506t'
      wrapper.setProps({ ...props })
      const object = instance.isDocumentType4506(props.document.type)

      expect(object).toBeTruthy()
    })
  })

  describe('#renderExpiredContainer', () => {
    let files = [
      {
        "rid": 58833119,
        "uuid": "cd7c241c-e533-49d4-9551-58a26ae6abe9",
        "isNew": true,
        "status": "FAILED",
        "name": "pdf-sample_2021-11-19_19_29_31_UTC_a9c730dd.pdf",
        "details": "NO_EXTRACTION",
        "referenceDate": new Date(2021, 9,18),
        "fileStatus": "PENDING_REVIEW"
      }
    ]
    let referenceFiles = [{date: new Date(2021, 9,18), status: 'PENDING_REVIEW'}]

    it('should include uuid', () => {
      const obj = instance.renderExpiredContainer(files, referenceFiles)

      expect(JSON.stringify(obj)).toContain('cd7c241c-e533-49d4-9551-58a26ae6abe9')
    })

    it('should include name', () => {
      const obj = instance.renderExpiredContainer(files, referenceFiles)

      expect(JSON.stringify(obj)).toContain('pdf-sample_2021-11-19_19_29_31_UTC_a9c730dd.pdf')
    })

    it('should render id', () => {
      const obj = instance.renderExpiredContainer(files, referenceFiles)

      expect(JSON.stringify(obj)).toContain('document_bucket_box')
    })
  })

  describe('#renderFileLink', () => {
    let file = {
      "rid": 58833119,
      "uuid": "cd7c241c-e533-49d4-9551-58a26ae6abe9",
      "isNew": true,
      "status": "FAILED",
      "name": "pdf-sample_2021-11-19_19_29_31_UTC_a9c730dd.pdf",
      "details": "NO_EXTRACTION",
      "referenceDate": new Date(2021, 9,18),
      "fileStatus": "PENDING_REVIEW"
    }

    it('should render id', () => {
      const obj = instance.renderFileLink(file)

      expect(JSON.stringify(obj)).toContain('fa fa-file-text-o')
    })

    it('should include filename', () => {
      const obj = instance.renderFileLink(file)

      expect(JSON.stringify(obj)).toContain('pdf-sample_2021-11-19_19_29_31_UTC_a9c730dd.pdf')
    })
  })

  describe('#hasReferences', () => {
    it('when referenceFiles is empty', () => {
      const { hasReferences } = wrapper.instance()

      expect(hasReferences).toBeFalsy()
    })
    it('when referenceFiles is not empty', () => {
      props.document.referenceFiles = "[{\"date\":\"2021-11-01\",\"status\":\"pending_review\"}]"
      wrapper.setProps({ ...props })

      const { hasReferences } = wrapper.instance()

      expect(hasReferences).toBeTruthy()
    })
  })

  describe('#disableRegenerate1919Button', () => {
    it('when disableRegenerate1919Button is false', () => {
      const { disableRegenerate1919Button } = wrapper.instance()

      expect(disableRegenerate1919Button).toBeFalsy()
    })

    it('when disableRegenerate1919Button is true', () => {
      props.document.status = 'approve_and_commit'
      wrapper.setProps({ ...props })

      const { disableRegenerate1919Button } = wrapper.instance()

      expect(disableRegenerate1919Button).toBeTruthy()
    })
  })

  describe('#showRegenerate1919Button', () => {
    it('when showRegenerate1919Button is false', () => {
      const { showRegenerate1919Button } = wrapper.instance();

      expect(showRegenerate1919Button).toBeFalsy()
    })

    it('when showRegenerate1919Button is true', () => {
      props.document.type = 'Document::T1919Business'
      wrapper.setProps({ ...props })

      const { showRegenerate1919Button } = wrapper.instance()

      expect(showRegenerate1919Button).toBeTruthy()
    })
  })

  describe('#display1919TooltipCopy', () => {
    it('when display1919TooltipCopy shows Regenerate Doc copy', () => {
      props.document.type = 'Document::T1919Business';
      props.document.status = 'pending_review'
      wrapper.setProps({ ...props })

      const { display1919TooltipCopy } = wrapper.instance()

      expect(display1919TooltipCopy).toEqual("Regenerate Document")
    })

    it('when display1919TooltipCopy shows to reapprove doc', () => {
      props.document.type = 'Document::T1919Business';
      props.document.status = 'approve_and_commit'
      wrapper.setProps({ ...props })

      const { display1919TooltipCopy } = wrapper.instance()

      expect(display1919TooltipCopy).toEqual("You must un-approve the document to regenerate")
    })
  })

  describe('#showExpiredDocument', () => {
    describe('when document type is not a BankStatement', () => {
      beforeAll(() => {
        props.document.type = "Document::Custom"
        wrapper.setProps({ ...props })
      })

      it('when hasReference is false', () => {
        const { showExpiredDocument } = wrapper.instance()

        expect(showExpiredDocument).toBeFalsy()
      })

      it('when hasReference is true', () => {
        props.document.referenceFiles = "[{\"date\":\"2021-11-01\",\"status\":\"pending_review\"}]"
        wrapper.setProps({ ...props })
        const { showExpiredDocument } = wrapper.instance()

        expect(showExpiredDocument).toBeFalsy()
      })
    })

    describe('when document type is a BankStatement', () => {
      beforeAll(() => {
        props.document.type = "Document::BankStatement"
        wrapper.setProps({ ...props })
      })

      it('when hasReference is true', () => {
        props.document.referenceFiles = "[{\"date\":\"2021-11-01\",\"status\":\"pending_review\"}]"
        wrapper.setProps({ ...props })
        const { showExpiredDocument } = wrapper.instance()

        expect(showExpiredDocument).toBeTruthy()
      })

      it('when hasReference is false', () => {
        props.document.referenceFiles = "[]"
        wrapper.setProps({ ...props })
        const { showExpiredDocument } = wrapper.instance()

        expect(showExpiredDocument).toBeFalsy()
      })
    })
  })
})
